import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from './services/transation.service.service';
// import { SurveyBuilderService } from '../../../services/survey-builder/survey-builder.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { MatDialog, MatSnackBar } from '@angular/material';
import { SnackBarComponent } from 'dhwani-material-library';
import { ConsentTranslateDialogComponent } from '../shared/consent-translate-dialog/consent-translate-dialog.component';
import { FileUploadComponent } from '../shared/file-upload/file-upload.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TempModuleService } from './services/temp-module.service';


interface Form {
    id: string,
    data: any[],

}

@Component({
    selector: 'app-form-translate',
    templateUrl: './form-translate.component.html',
    styleUrls: ['./form-translate.component.css'],
    providers:[TempModuleService]
})
export class FormTranslateComponent implements OnInit {
    @ViewChild('donwload') donwloadAnchor: ElementRef;
    @ViewChild('fileUpload') fileUpload: any;
    instructionsList = [
        'File should be in ".xlsx" format.',
        'File should not be empty.',
        'File should contain exact 4 columns in specific order - "shortKey, Information, en, <otherLanguageCode>"',
        'shortKey column - unique shortKey of the question. e.g - default value- "order<no>" - "order7"',
        'Information column - particular field of the question for which we want to submit translation for - i.e. "title/hint/information/answer_option/resource_urls"',
        '"en" column - represents the english version of the question.',
        '<otherLanguageCode> column - represents other language questions in which we want to upload the translation for. e.g. - "shortKey, Information, en, hi"',
    ];
    public originalTranslationStringArray: Map<any, any> = new Map();
    public form: Form = { id: '', data: [] };
    public languages: any[] = [];
    public formLanguages: string[] = [];
    public selected = new FormControl(0);
    public helperForm: FormGroup;
    public isOriginalCopied: boolean = false;
    private urls: any[] = [];
    public urlMap: Map<string, string> = new Map<string, string>();
    project_name: string = sessionStorage.getItem('project_name');
    form_name: string = sessionStorage.getItem('form_name');

    temp_formId = ''
    translatedLanguages: any = [];
    nonTranslatedLanguages: any = [];
    errorMessage: string = '';
    showErrorMessage = false;
    progressBar = false;
    constructor(private formBuilder: FormBuilder,
        private router: Router,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        public surveyBuilderService: TempModuleService,
        public translationService: TranslationService) {

        this.helperForm = this.formBuilder.group({
            language: [[]],
            label: ['', Validators.required]
        });
    }

    ngOnInit() {
        this.route.params.subscribe((param: any) => {
            if (param.id) {
                this.translationService.setFormId(param.id);
                this.form.id = param.id;
                this.getFormStringDetails();
                this.getFormDetails();
            }
        });
    }

    getFormStringDetails() {

        this.translationService.getFormStringDetails().then((response: any) => {
            if (response.success) {
                this.urls = response.urls;
                response.string.forEach((el) => {
                    this.originalTranslationStringArray.set(el, '');
                });
            }
        });
    }

    languageSelectHandler(event) {

        this.helperForm.value.language.filter(e => !e.hasOwnProperty('translationString'))
            .forEach(e => e['translationString'] = new Map(this.originalTranslationStringArray));
    }

    getFormDetails() {
        this.progressBar = true;
        this.surveyBuilderService.getFormDetails(this.form.id)
            .then((response: any) => {
                if (response.success) {
                    this.progressBar = false;
                    this.form.data = response.data[0];
                    this.temp_formId = response && response.data && response.data[0] && response.data[0].formId;
                    this.getLanguages();
                }
            })
            .catch(err => {
                this.progressBar = false;
                this.handlerError;
            });
    }

    getLanguages() {
        this.translationService.getLanguages(this.form.id).then((response: any) => {
            if (response.success) {
                let translatedLangs = [];
                let nonTranslatedLangs = [];
                this.formLanguages = response.formLanguages;
                this.languages = response.data.filter(ln => ln.code != 'en');
                for (const language of this.languages) {
                    if (this.formLanguages.includes(language.code)) {
                        translatedLangs.push(language);
                    } else {
                        nonTranslatedLangs.push(language);
                    }
                }
                this.concateLanguage(translatedLangs, nonTranslatedLangs);
            }
        });
    }

    concateLanguage(translatedLangs, nonTranslatedLangs) {
        this.translatedLanguages = translatedLangs.map(e => `${e.name} (${e.code})`).join(' - ');
        this.nonTranslatedLanguages = nonTranslatedLangs.map(e => `${e.name} (${e.code})`).join(' - ');
    }

    hasConsentQuestion() {
        const questionArray = this.form.data['language'].find((lanuage) => lanuage.lng == 'en');
        if (questionArray) {
            return questionArray.question.find(q => q.input_type == 22);
        }
        return false;

    }

    async CopyOriginalText() {

        let copyString = Array.from(this.originalTranslationStringArray.keys()).join('\n');
        try {
            await window.navigator['clipboard'].writeText(copyString);
            this.isOriginalCopied = true;
            this.openSnackBar(['Text copied'], 2500);
        } catch (e) {
            console.log(e);
        }
    }

    translateConsentClickHandler(language) {
        const diaglogRef = this.dialog.open(ConsentTranslateDialogComponent, {
            data:
            {
                url: this.urls,
                language
            }

        });
        diaglogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.urlMap = new Map<string, string>(result);
            }
        });

    }

    async pasteAllText(tab) {
        if (this.isOriginalCopied) {
            try {
                let text = await window.navigator['clipboard'].readText();
                let textArray = Array.from(text.split('\n'));
                Array.from(tab.translationString)
                    .forEach((el, i) => {
                        let id = `tabe-${tab.code}${i}`;
                        let element = document.getElementById(id) as HTMLTextAreaElement;
                        tab.translationString.set(el[0], textArray[i] || '');
                    });
            } catch (e) {
                console.log(e);
            }
        }
    }

    submitTranslation(tab, event) {
        event.disabled = true;
        let isEmpty = 0;
        let body = {};
        tab.translationString.forEach((el, i) => {
            if (el && el.length > 0) {
                body[i] = el;
            } else {
                isEmpty = 1;
            }
        });
        if (isEmpty == 1) {

            this.openSnackBar(['One or more field is missing'], 2500);
            event.disabled = false;
            return;
        }
        if (this.urlMap.size > 0) {
            this.urlMap.forEach((el, i) => {
                if (el && el.length > 0) {
                    body[i] = el;
                }
            });
        }
        body['language'] = tab.code;
        this.translationService.updateLanguages(this.form.id, body).then((response) => {
            if (response['success']) {
                this.openSnackBar(['Translation added Successfully'], 2500);
                event.disabled = false;
            }
        }).catch((error) => {
            this.openSnackBar(['Some error occurred'], 2500);
            event.disabled = false;
            this.handlerError(error);
        }
        );

    }

    checkForPaste() {
        return this.isOriginalCopied;
    }

    textAreaChangeHandler(tab, string, event) {
        tab.translationString.set(string.key, event.target.value);
    }

    private openSnackBar(message: string[], duration: number) {
        this.snackBar.openFromComponent(SnackBarComponent, {
            data: message,
            duration
        });
    }

    handlerError(response) {
        console.log(response);
    }

    handleBackNavi(path: string) {
        if (path) {
            this.router.navigate([path]);
        } else {
            window.history.back();
        }
    }

    downloadTranslationFormat() {
        if (this.temp_formId) {
            const apiRoute = this.translationService.getTranslationFormat(this.temp_formId);
            this.donwloadAnchor.nativeElement.href = apiRoute;
            this.donwloadAnchor.nativeElement.click();
        }
    }

    onSelectFile(event) {
        this.progressBar = true;
        this.showErrorMessage = false;
        const files = event.target.files[0];
        const formData = new FormData();
        formData.append('datasetCsv', files);
        this.translationService.uploadTranslationData(this.temp_formId, formData).then((response: any) => {
            if ((response.success) && (response.data)) {
                this.fileUpload.nativeElement.value = '';
                this.progressBar = false;
                this.openSnackBar([response.message], 5000);
            } else {
                this.fileUpload.nativeElement.value = '';
                this.progressBar = false;
                this.errorMessage = response.err;
                this.showErrorMessage = true;
            }
        }).catch(err => {
            this.fileUpload.nativeElement.value = '';
            this.progressBar = false;
            this.errorMessage = err && err.error && err.error.err;
            this.showErrorMessage = true;
        });
    }

    // onSelectFile(event) {
    //     this.progressBar = true;
    //     this.showErrorMessage = false;
    //     const files = event;
    //     const formData = new FormData();
    //     formData.append('datasetCsv', files);
    //     this.translationService.uploadTranslationData(this.temp_formId, formData).then((response: any) => {
    //         if ((response.success) && (response.data)) {
    //             this.fileUpload.nativeElement.value = '';
    //             this.progressBar = false;
    //             this.openSnackBar([response.message], 5000);
    //         } else {
    //             this.fileUpload.nativeElement.value = '';
    //             this.progressBar = false;
    //             this.errorMessage = response.err;
    //             this.showErrorMessage = true;
    //         }
    //     }).catch(err => {
    //         this.fileUpload.nativeElement.value = '';
    //         this.progressBar = false;
    //         this.errorMessage = err && err.error && err.error.err;
    //         this.showErrorMessage = true;
    //     });
    // }

    openFileUpload() {
        const data = {
            multipleSelect: false,
            acceptedValues: '.xlsx'
        }
        const dialogRef = this.dialog.open(FileUploadComponent, {
            width: '820px',
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('result', result);
            if (result && result.data) {
                this.onSelectFile(result.data)
            }
        });
    }
}
